import { AuthConfig } from "@auth0/auth0-angular";
import { environment } from "../environments/environment";

export const auth0Config: AuthConfig = {
  domain: environment.auth0Domain,
  clientId: environment.auth0ClientID,
  redirectUri: environment.auth0RedirectUrl,
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  audience: "reveleer-api",
  httpInterceptor: {
    allowedList: [
       {
        uri: `${environment.baseApiUrl}*`,
        tokenOptions: {
          audience: "reveleer-api",
        },
        // Will remove this option after we build complete Auth0 setup
        allowAnonymous: true,
      },
    ],
  },
};
